/* eslint-disable no-console */
import React, { FC, useEffect, useState } from 'react'

import './styles.scss'
import { useDispatch, useSelector } from 'react-redux'
import Availabilities from '../../../Components/availabilities/Availabilities'
import { IProps } from './types'
import { ApiResponse,
  Availability,
  MeetingPageField,
  MeetingPageFieldType,
  MeetingStatus } from '../../../types/plann3r'
import { setLinkResponseReceived } from '../../../store/meeting-page/actions'
import { createLinkMeeting, sendResponse } from '../../../api/api'
import { MeetingPageStore } from '../../../store/meeting-page/types'
import { Plann3rStore } from '../../../store/types'
import moment from 'moment-timezone'
import Loading from '../../../Components/loading/Loading'
import { AvailabilitiesStore } from '../../../store/availabilities/types'
import { setCurrentAvailabilities } from '../../../store/availabilities/actions'
import { SettingsStore } from '../../../store/settings/types'

const PickAMoment: FC<IProps> = () => {
  const [loading, setloading] = useState(false)
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.link.chooseamoment,
  )
  const { timezone } = useSelector((state: Plann3rStore): SettingsStore => state.settings)
  const { language } = useSelector((state: Plann3rStore) => state.languages)
  const {
    fields,
    duration,
    logo,
    display_name,
    id,
    isVideoCall,
  } = useSelector((state: Plann3rStore): MeetingPageStore => state.meetingPage)

  const { availabilities } = useSelector(
    (state: Plann3rStore): AvailabilitiesStore => state.availabilities,
  )

  const dispatch = useDispatch()

  useEffect(() => {
    const location = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.LOCATION
    })[0].value

    dispatch(setCurrentAvailabilities(location + '', duration + ''))
  }, [dispatch, fields, duration])

  const handleCreateMeetingReceived = (response: ApiResponse) => {
    if (
      response.success &&
      response.meeting_id &&
      response.user_key &&
      response.user_id
    ) {
      sendMeetingAvailabilities(response.meeting_id, response.user_key, response.user_id)
    } else {
      alert('Something went wrong. Please try again.')
    }
  }

  const handleMeetingResponseReceived = (response: ApiResponse) => {
    if (response.success) {
      setloading(false)
      dispatch(setLinkResponseReceived())
    }
  }

  const sendMeetingAvailabilities = (meetingId: number, meetingKey: string, inviteeId: number) => {
    if (meetingKey) {
      const meeting_response_info = {
        key: meetingKey,
        status: MeetingStatus.CONFIRMED,
        availabilities:
          availabilities && availabilities.length > 0
            ? JSON.stringify(
              availabilities
                .filter(function(el: Availability) {
                  return el.selected === true
                })
                .map(function(el: Availability) {
                  return {
                    start: moment(el.start).format('YYYY-MM-DDTHH:mm:ssZZ'),
                    end: moment(el.end).format('YYYY-MM-DDTHH:mm:ssZZ'),
                  }
                }),
            )
            : '',
        meeting_id: meetingId,
        user_id: inviteeId,
      }
      sendResponse(meeting_response_info).then(handleMeetingResponseReceived).catch((e) => console.log(e))
    } else {
      alert(strings.valid_key)
    }
  }

  const sendMeetingRequest = () => {
    const email = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.EMAIL
    })[0].value

    const name = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.NAME
    })[0].value

    const location = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.LOCATION
    })[0].value

    const create_meeting_info = {
      pageId: id,
      email: email,
      fullname: name,
      location: location,
      subject: 'Meeting ' + name + ' - ' + display_name,
      virtual: isVideoCall,
      start: moment(new Date()).startOf('day').format('YYYY-MM-DDTHH:mm:ssZZ'),
      duration: duration,
      custom: JSON.stringify(fields),
      language: language,
      timezone,
    }

    setloading(true)

    createLinkMeeting(create_meeting_info).then(handleCreateMeetingReceived).catch((e) => console.log(e))
  }

  if (loading) return <Loading />

  return (
    <div className="chooseMoment">
      <div className="top has-text-centered">
        <div>
          <span className="heavy">{strings.duration}</span>
          <span>{duration + ' min'}</span>
        </div>
        <img
          src={logo}
          alt={display_name}
          className="logoCompanyPage"
        />
        <div>
          <span className="heavy">{strings.timezone}</span>
          <span>{timezone}</span>
        </div>
      </div>
      <div className="availabilitiesContainer">
        <Availabilities
          onConfirm={sendMeetingRequest}
          name={display_name}
          duration={duration}
        />
      </div>
    </div>
  )
}

export default PickAMoment
